import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { isBrowser } from '@sravni/react-utils';

let portalContainer = null;
const portalAttribute = 'sr-portal-container';
const Portal = React.memo((props) => {
    const { children } = props;
    const portal = React.useMemo(() => {
        if (!isBrowser) {
            return null;
        }
        if (portalContainer) {
            return portalContainer;
        }
        const el = document.querySelector(`div[${portalAttribute}]`);
        if (el) {
            portalContainer = el;
            return portalContainer;
        }
        portalContainer = document.createElement('div');
        portalContainer.setAttribute(portalAttribute, '');
        document.body.appendChild(portalContainer);
        return portalContainer;
    }, []);
    if (!isBrowser) {
        return null;
    }
    if (portal) {
        return ReactDOM.createPortal(children, portal);
    }
    return null;
});
Portal.displayName = 'Portal';

export { Portal };
//# sourceMappingURL=Portal.js.map
